import React from "react";
import {connect} from 'react-redux'
import Header from "../../../Components/Header/index"
import Footer from "../../../Components/Footer/index"
import PubHubDoc from "./PubHubDoc"
import Breadcrumb from "./Breadcrumb"

export default class extends React.Component {

    constructor() {
        super();

        this.docOnLoad = this.docOnLoad.bind(this);
        this.docOnChange = this.docOnChange.bind(this);

        this.state = {
            docstore: null,
            error: false,
        }
    }

    docOnLoad(docstore, docinstance) {
        this.setState({
            docstore
        })
    }

    docOnChange(uri, docinstance) {

    }

    // componentDidMount() {
    //     AOS.init({
    //         disable: 'mobile'
    //     });
    // }

    render() {
        let {projectName} = this.props.params;
        const {uri, phlocation, setting} = this.props.route;

        let header = <Header setting={setting}/>;

        if (uri) {
            projectName = uri;
        }

        const docstore = this.state.docstore || {};

        return (
            <div>
                {header}
                <div id="devnet-doc-header"/>
                <Breadcrumb config={docstore.config} meta={docstore.meta}/>
                {this.state.error ? (
                    <div className="container">
                        <div style={{ marginTop: '1rem' }} className="alert alert-warning" role="alert">
                            Doc does not exist.
                        </div>
                    </div>
                ) : (
                    <PubHubDoc
                        projectName={projectName}
                        {...this.props}
                        onload={this.docOnLoad}
                        onchange={this.docOnChange}
                        phlocation={phlocation}
                        setError={() => this.setState({ error: true })}
                    />
                )}
                <Footer setting={setting} />
            </div>
        )
    }
}
